import { stringOrArrayToArray } from './helpers';

import {
    OAUTHS_APPLE_SCOPE,
    OAUTHS_APPLE_URL,
    OAUTHS_FACEBOOK_SCOPE,
    OAUTHS_FACEBOOK_URL,
    OAUTHS_GOOGLE_SCOPE,
    OAUTHS_GOOGLE_URL,
} from 'app/constants';
import { IProviders } from 'app/ui-auth/config-interfaces';
import { environment } from 'environments/environment';

const OAUTH_MAP = {
    apple: { scope: OAUTHS_APPLE_SCOPE, url: OAUTHS_APPLE_URL },
    facebook: { scope: OAUTHS_FACEBOOK_SCOPE, url: OAUTHS_FACEBOOK_URL },
    google: { scope: OAUTHS_GOOGLE_SCOPE, url: OAUTHS_GOOGLE_URL },
};

export function getOauthProviders(): IProviders {
    const oauths = environment.oauths || {};

    return (Object.entries(oauths) as [keyof IProviders, any][]).reduce((acc, [key, config]) => {
        const staticConfig = OAUTH_MAP[key as keyof typeof OAUTH_MAP];

        if (config?.clientId && staticConfig) {
            acc[key] = {
                clientId: config.clientId,
                scope: stringOrArrayToArray(staticConfig.scope),
                url: staticConfig.url,
                responseType: config.responseType,
                ...(config.redirectUrl && { redirectUri: config.redirectUrl }),
            };
        }
        return acc;
    }, {} as IProviders);
}
